var swiper = new Swiper(".swiper-home-slider", {
  autoplay: {
    delay: 20000,
    disableOnInteraction: false,
  },
  pagination: {
    el: ".swiper-pagination-home-slider",
    clickable: true,
  },
});

function myPlugin({ swiper, extendParams, on }) {
  extendParams({
    debugger: false,
  });

  on("init", () => {
    if (!swiper.params.debugger) return;
    console.log("init");
  });
  on("click", (swiper, e) => {
    if (!swiper.params.debugger) return;
    console.log("click");
  });
  on("tap", (swiper, e) => {
    if (!swiper.params.debugger) return;
    console.log("tap");
  });
  on("doubleTap", (swiper, e) => {
    if (!swiper.params.debugger) return;
    console.log("doubleTap");
  });
  on("sliderMove", (swiper, e) => {
    if (!swiper.params.debugger) return;
    console.log("sliderMove");
  });
  on("slideChange", () => {
    if (!swiper.params.debugger) return;
    console.log("slideChange", swiper.previousIndex, "->", swiper.activeIndex);
  });
  on("slideChangeTransitionStart", () => {
    if (!swiper.params.debugger) return;
    console.log("slideChangeTransitionStart");
  });
  on("slideChangeTransitionEnd", () => {
    if (!swiper.params.debugger) return;
    console.log("slideChangeTransitionEnd");
  });
  on("transitionStart", () => {
    if (!swiper.params.debugger) return;
    console.log("transitionStart");
  });
  on("transitionEnd", () => {
    if (!swiper.params.debugger) return;
    console.log("transitionEnd");
  });
  on("fromEdge", () => {
    if (!swiper.params.debugger) return;
    console.log("fromEdge");
  });
  on("reachBeginning", () => {
    if (!swiper.params.debugger) return;
    console.log("reachBeginning");
  });
  on("reachEnd", () => {
    if (!swiper.params.debugger) return;
    console.log("reachEnd");
  });
}

var swiper_home_nuestras_soluciones = new Swiper(
  ".swiper-home-nuestras-soluciones",
  {
    modules: [myPlugin],

    autoplay: {
      delay: 20000,
      disableOnInteraction: false,
    },

    pagination: {
      el: ".swiper-pagination-home-nuestras-soluciones",
      clickable: true,
    },
    navigation: {
      nextEl: ".swiper-button-next",
      prevEl: ".swiper-button-prev",
    },
    breakpoints: {
      300: {
        slidesPerView: 1,
      },
      768: {
        slidesPerView: 2,
        spaceBetween: 10,
      },
      1024: {
        slidesPerView: 3,
        spaceBetween: 10,
      },
      1536: {
        slidesPerView: 3,
      },
    },
  }
);

var swiper = new Swiper(".swiper-home-impulsa-negocio", {
  modules: [myPlugin],
  breakpoints: {
    300: {
      slidesPerView: 1,
    },
    // 700: {
    //   spaceBetween: 30,
    //   slidesPerView: 2,
    // },
    1024: {
      spaceBetween: -70,
      slidesPerView: 2,
    },
    1400: {
      spaceBetween: 30,
      slidesPerView: 2,
    },
  },

  autoplay: {
    delay: 20000,
    disableOnInteraction: false,
  },
  pagination: {
    el: ".swiper-pagination-home-impulsa-negocio",
    clickable: true,
  },
});

var swiper = new Swiper(".swiper-home-servicios-mes", {
  modules: [myPlugin],
  centeredSlides: true,
  autoplay: {
    delay: 20000,
    disableOnInteraction: false,
  },
  navigation: {
    nextEl: ".swiper-button-next",
    prevEl: ".swiper-button-prev",
  },
});

var swiper = new Swiper(".swiper-marcas-confianza", {
  modules: [myPlugin],
  slidesPerView: 5,
  spaceBetween: 10,
  pagination: {
    el: ".swiper-paginations-marcas-confianza",
  },
  autoplay: {
    delay: 20000,
    disableOnInteraction: false,
  },
  breakpoints: {
    300: {
      slidesPerView: 3,
      spaceBetween: 5,
    },
    768: {
      slidesPerView: 5,
      spaceBetween: 10,
    },
  },
});

// swiper-interna-casos-exito-reto

var swiper = new Swiper(".swiper-interna-casos-exito-reto", {
  modules: [myPlugin],
  pagination: {
    el: ".swiper-paginations-marcas-confianza",
  },
  autoplay: {
    delay: 20000,
    disableOnInteraction: false,
  },
  breakpoints: {
    300: {
      slidesPerView: 1,
    },
    370: {
      slidesPerView: 2,
      spaceBetween: 10,
    },
  },
});

/*Slider Interna Producto Servicio*/

var swiper = new Swiper(".swiper-interna-producto-servicio-slider", {
  modules: [myPlugin],
  //spaceBetween: 30,
  // Install Plugin To Swiper
  // modules: [myPlugin],
  /* pagination: {
    el: '.swiper-pagination',
    clickable: true,
  }, */
  navigation: {
    nextEl: ".swiper-button-next",
    prevEl: ".swiper-button-prev",
  },
  autoplay: {
    delay: 20000,
    disableOnInteraction: false,
  },
  breakpoints: {
    300: {
      slidesPerView: 1,
    },
    1024: {
      slidesPerView: 3,
      spaceBetween: 30,
    },
  },
  pagination: {
    el: ".swiper-pagination-interna-producto-servicio-slider",
    clickable: true,
  },
});

/*Slider interna_producto_slider_benificio*/
var swiper = new Swiper(".swiper-interna-producto-slider-beneficio", {
  modules: [myPlugin],
  autoplay: {
    delay: 20000,
    disableOnInteraction: false,
  },

  breakpoints: {
    300: {
      slidesPerView: 1,
      spaceBetween: -60,
    },
    1024: {
      slidesPerView: 2,
      spaceBetween: 30
    },
    1280: {
      slidesPerView: 3,
      spaceBetween: 30
    },
  },
  pagination: {
    el: ".swiper-pagination-interna-producto-slider-beneficio",
    clickable: true,
  },
  navigation: {
    nextEl: ".swiper-button-next",
    prevEl: ".swiper-button-prev",
  },
});

/*swiper-interna-casos-exito-que-hicimos*/

var swiper = new Swiper(".swiper-interna-casos-exito-que-hicimos", {
  modules: [myPlugin],
  slidesPerView: 3,
  spaceBetween: 700,
  autoplay: {
    delay: 20000,
    disableOnInteraction: false,
  },
  pagination: {
    el: ".swiper-interna-casos-exito-que-hicimos",
    clickable: true,
  },
});

/*Slider interna_producto_intereses*/

var swiper = new Swiper(".swiper-interna-producto-intereses", {
  modules: [myPlugin],
  breakpoints: {
    300: {
      slidesPerView: 1,
    },
    1200: {
      spaceBetween: 30,
      slidesPerView: 2,
    },
  },

  autoplay: {
    delay: 20000,
    disableOnInteraction: false,
  },
  pagination: {
    el: ".swiper-pagination-interna-producto-intereses",
    clickable: true,
  },
});

var swiper = new Swiper(".swiper-casos-exito-row", {
  modules: [myPlugin],
  //slidesPerView: 3,
  //spaceBetween: 30,
  // Install Plugin To Swiper
  // modules: [myPlugin],
  /* pagination: {
    el: '.swiper-pagination',
    clickable: true,
  }, */
  autoplay: {
    delay: 20000,
    disableOnInteraction: false,
  },
  navigation: {
    nextEl: ".swiper-button-next",
    prevEl: ".swiper-button-prev",
  },
  pagination: {
    el: ".swiper-pagination-swiper-casos-exito-row",
    clickable: true,
  },
});

var swiper_ = new Swiper(".swiper-marcas-confianza-contactanos", {
  modules: [myPlugin],
  slidesPerView: 5,
  autoplay: {
    delay: 20000,
    disableOnInteraction: false,
  },

  pagination: {
    el: ".swiper-pagination-interna-producto-intereses",
    clickable: true,
  },
});

/*Swiper herramientas de evaluo*/

var swiper = new Swiper(".swiper-interna-producto-2-beneficio", {
  modules: [myPlugin],
  pagination: {
    el: ".swiper-pagination",
    clickable: true,
  },

  autoplay: {
    delay: 20000,
    disableOnInteraction: false,
  },
});

/*Swiper macro soluciones logros*/

var swiper = new Swiper(".Myswiper", {
  modules: [myPlugin],
  navigation: {
    nextEl: ".swiper-button-next",
    prevEl: ".swiper-button-prev",
  },
  autoplay: {
    delay: 20000,
    disableOnInteraction: false,
  },

  pagination: {
    el: ".swiper-pagination-Myswiper",
    clickable: true,
  },
});

/*Swiper contactanos*/

var swiper = new Swiper(".Myswiper-contactanos", {
  modules: [myPlugin],
  autoplay: {
    delay: 20000,
    disableOnInteraction: false,
  },
  breakpoints: {
    768: {
      slidesPerView: 3,
      spaceBetween: -60,
    },
    1024: {
      slidesPerView: 5,
      spaceBetween: -70,
    },
  },
});

/*Interna Casos Exito Que Hicimos Slider Mobile*/

var swiper = new Swiper(".MySwiper-mobile-logros", {
  modules: [myPlugin],
  centeredSlides: true,
  autoplay: {
    delay: 20000,
    disableOnInteraction: false,
  },
  pagination: {
    el: ".swiper-pagination",
    clickable: true,
  },
});

/*Quienes sosmos experiencias*/
var swiper = new Swiper(".quienes-somos-experiencias", {
  modules: [myPlugin],
  autoplay: {
    delay: 20000,
    disableOnInteraction: false,
  },
  breakpoints: {
    300: {
      slidesPerView: 1,
    },
    768: {
      slidesPerView: 2,
    },
    1024: {
      slidesPerView: 3,
    },
  },
});

/* ayuda-soporte-compra-servicios */
var swiper = new Swiper(".ayuda-soporte-compra-servicios", {
  modules: [myPlugin],
  centeredSlides: true,
  autoplay: {
    delay: 20000,
    disableOnInteraction: false,
  },
  navigation: {
    nextEl: ".swiper-button-next",
    prevEl: ".swiper-button-prev",
    clickable: true,
  },
});

/*Tiempos y resultados*/

var swiper = new Swiper(".ayuda-soporte-tiempos-resultados", {
  modules: [myPlugin],
  slidesPerView: 1,
  rewind: true,
  centeredSlides: true,
  autoplay: {
    delay: 20000,
    disableOnInteraction: false,
  },
});

var swiper_ = new Swiper(".swiper-interna-caso-exito-intereses", {
  modules: [myPlugin],
  autoplay: {
    delay: 20000,
    disableOnInteraction: false,
  },

  pagination: {
    el: ".swiper-pagination-interna-caso-exito-intereses",
    clickable: true,
  },

  breakpoints: {
    300: {
      slidesPerView: 1,
      spaceBetween: -60,
    },
    768: {
      slidesPerView: 1,
    },
    1200: {
      slidesPerView: 2,
      spaceBetween: 30,
    },
  },
});

var swiper = new Swiper(".swiper-interna-producto-que-hicimos", {
  modules: [myPlugin],
  //spaceBetween: 30,
  // Install Plugin To Swiper
  // modules: [myPlugin],
  /* pagination: {
    el: '.swiper-pagination',
    clickable: true,
  }, */
  navigation: {
    nextEl: ".swiper-button-next",
    prevEl: ".swiper-button-prev",
  },
  autoplay: {
    delay: 20000,
    disableOnInteraction: false,
  },
  breakpoints: {
    300: {
      slidesPerView: 1,
      spaceBetween: -60,
    },
    768: {
      slidesPerView: 1,
    },
    1024: {
      slidesPerView: 3,
      spaceBetween: 30,
    },
  },
  pagination: {
    el: ".swiper-pagination-interna-producto-que-hicimos",
    clickable: true,
  },
});